import moment from "moment";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import { getRequiredErrorMessage } from "../Shared/Constants/AdminModuleConstants";
import WorkHourService from "../Shared/Services/WorkHourService";
import { WorkHour } from "./Models/workHour";
import { TimePicker } from '@progress/kendo-react-dateinputs';

export const UpdateWorkHour = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { control, handleSubmit, setValue, reset, formState: { errors } } = useForm();
    const [workHour, setWorkHour] = useState<WorkHour>();

    useEffect(() => {
        getWorkHourId(Number(id));
    }, []);

    const getDateObject = (timeString: any) => {
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(Number(hours));
        date.setMinutes(Number(minutes));
        return date;
    }

    const getWorkHourId = (id: number) => {
        WorkHourService.getWorkHourById(id).then((response) => {
            setWorkHour(response.data);
            setValue('standardEndTime', getDateObject(response.data.standardEndTime));
            setValue('standardStartTime', getDateObject(response.data.standardStartTime));
            setValue('normalSessionLength', getDateObject(response.data.normalSessionLength));
            setValue('premiumSessionLength', getDateObject(response.data.premiumSessionLength));
            setValue('premiumStartTime', getDateObject(response.data.premiumStartTime));
            setValue('premiumEndTime', getDateObject(response.data.premiumEndTime));
        })
            .catch((error) => {
                console.log(`Error : Something went wrong while getting contracts by id ${id}`, error)
            });
    }

    const validateTimeRange = (data: any) => {
        var isValidTimeRange = true;
        var standardStartTime = moment(data.standardStartTime, 'HH:mm', true);
        var standardEndTime = moment(data.standardEndTime, 'HH:mm', true);
        var premiumStartTime = moment(data.premiumStartTime, 'HH:mm', true);
        var premiumEndTime = moment(data.premiumEndTime, 'HH:mm', true);

        if (standardStartTime.isValid() && standardEndTime.isValid()) {
            if (standardEndTime.isBefore(standardStartTime)) {
                isValidTimeRange = false;
                SweetAlertService.error("Error", "Standard End Time should be greater than Standard Start Time");
            }
        }
        if (standardStartTime.isValid() && standardEndTime.isValid() && premiumStartTime.isValid() && premiumEndTime.isValid()) {
            if (premiumStartTime.isBetween(standardStartTime, standardEndTime)) {
                isValidTimeRange = false;
                SweetAlertService.error("Error", "Premium time range should not be present between a standard time range");
            }
            if (premiumEndTime.isBetween(standardStartTime, standardEndTime)) {
                isValidTimeRange = false;
                SweetAlertService.error("Error", "Premium time range should not be present between a standard time range");
            }
        }
        return isValidTimeRange;
    };

    const onSubmit = (data: any) => {
        data.id = Number(id);
        data.countryId = workHour?.countryId;
        data.premiumStartTime = moment(data.premiumStartTime).format('HH:mm');
        data.premiumEndTime = moment(data.premiumEndTime).format('HH:mm');
        data.normalSessionLength = moment(data.normalSessionLength).format('HH:mm');
        data.premiumSessionLength = moment(data.premiumSessionLength).format('HH:mm');
        data.standardStartTime = moment(data.standardStartTime).format('HH:mm');
        data.standardEndTime = moment(data.standardEndTime).format('HH:mm');
        const isValid = validateTimeRange(data);
        if (isValid) {
            WorkHourService.updateWorkHour(Number(id), data).then((res) => {
                console.log(res.data.data);
                if (res) {
                    //Reset form
                    reset();
                    navigate("/workhour");
                } else {
                }
            }).catch(error => {
                if (error) {
                    SweetAlertService.error("Error", error.response.data.errors[""]);
                }
            })
        }
    };

    return (
        <>
            <div className="card card-default" >
                <div className="card-header">
                    <h4>Edit Work hour</h4>
                </div>
                <form className="form-control" onSubmit={handleSubmit(onSubmit)}>
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label">
                            Country
                        </label>
                        <div className="col-sm-9">
                            {workHour?.countryName}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label">Role</label>
                        <div className="col-sm-9">
                            <div className="d-flex flex-row">
                                GP
                            </div>
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label"> Sub Role</label>
                        <div className="col-sm-9">
                            <div className="d-flex flex-row">
                                Salaried GP
                            </div>
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label">Contract</label>
                        <div className="col-sm-9">
                            <div className="d-flex flex-row">
                                2020
                            </div>
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label justify-content-center">
                            Standard Start Time
                        </label>
                        <div className="col-sm-9">
                            <Controller
                                name="standardStartTime"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Standard start time") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="standardStartTime"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.standardStartTime &&
                                (<span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.standardStartTime.message?.toString()}
                                </span>
                                )}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label justify-content-center">
                            Standard End Time
                        </label>
                        <div className="col-sm-9">
                            <Controller
                                name="standardEndTime"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Standard end time") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="standardEndTime"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.standardEndTime && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.standardEndTime.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label justify-content-center">
                            Premium Start Time
                        </label>
                        <div className="col-sm-9">
                            <Controller
                                name="premiumStartTime"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Premium start time") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="premiumStartTime"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.premiumStartTime && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.premiumStartTime.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label justify-content-center">
                            Premium End Time
                        </label>
                        <div className="col-sm-9">
                            <Controller
                                name="premiumEndTime"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Premium end time") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="premiumEndTime"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.premiumEndTime && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.premiumEndTime.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label justify-content-center">
                            Normal Session Length
                        </label>
                        <div className="col-sm-9">
                            <Controller
                                name="normalSessionLength"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Normal session length") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="normalSessionLength"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.normalSessionLength && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.normalSessionLength.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-sm-3 control-label justify-content-center">
                            Premium Session Length
                        </label>
                        <div className="col-sm-9">
                            <Controller
                                name="premiumSessionLength"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Premium session length") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="premiumSessionLength"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.premiumSessionLength && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.premiumSessionLength.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <div className=" col-sm-offset-3">
                            <button className="btn btn-secondary" onClick={() => navigate('/workhour')} >Back</button>
                            <button className="btn btn-primary ms-1" type="submit">Save</button>
                        </div>
                    </div>
                </form>
            </div >
        </>
    )
}